/** When section conditions are not met: show greyed step vs hide step entirely. */
export enum FormTemplateSectionVisibilityEnum {
    Disabled = 1,
    Invisible = 2,
}
